import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReadourblogsdata } from "../redux/action/homeAction";
import { useNavigate, useParams } from "react-router-dom";
import config from "../utilities/config";
import constants from "../utilities/constants";
import { formatDate } from "../utilities/helper";
import SeoHelmet from "../components/SeoHelmet";

const StyloriBlog = () => {
  const dispatch = useDispatch();
  const { title } = useParams();
  const navigation = useNavigate();

  const { readOurBlogsDataResponseSuccess } = useSelector(
    (state) => state.homeReducer
  );

  let blogs = readOurBlogsDataResponseSuccess?.props?.cardContent || [];
  blogs = blogs?.filter((a) => a.heading === title);
  config.logGeneral && console.log(blogs, "6543");

  useEffect(() => {
    dispatch(getReadourblogsdata());
  }, []);

  // Define link keywords
  const keywordLinks = [
    {
      keyword: "silver stud earrings",
      url: "/styloriSilver/earrings-silver-studs-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    },
    {
      keyword: "Silver jhumkas",
      url: "/styloriSilver/earrings-silver-jhumkas+online-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    },
    {
      keyword: "Silver choker necklaces",
      url: "/styloriSilver/silver-chokers-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    },
    {
      keyword: "Silver Drop earrings",
      url: "/styloriSilver/silver-long+earrings+drops-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0",
    },
    {
      keyword: "silver Victorian necklaces",
      url: "/styloriSilver/silver-necklaces-jewellery-victorian?sort=New%20to%20Stylori&startprice=0&endprice=0",
    },
    {
      keyword: "silver kundan bangles",
      url: "/styloriSilver/bangles-silver-jewellery-deep+nagas+kundan?sort=New%20to%20Stylori&startprice=0&endprice=0",
    },
    {
      keyword: "silver zircons necklaces",
      url: "/styloriSilver/silver-jewellery-necklaces-cubiczircon+swarovski?sort=New%20to%20Stylori&startprice=0&endprice=0",
    },
  ];

  const linkifyKeywords = (text) => {
    keywordLinks.forEach(({ keyword, url }) => {
      const regex = new RegExp(`(${keyword})`, "gi");
      text = text.replace(
        regex,
        `<a href="${url}" class="underline" style="color: rgb(6 171 159 / var(--tw-text-opacity))">$1</a>`
      );
    });
    return text;
  };

  const renderContentWithHeadings = (htmlText) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlText}</div>`, "text/html");
    const blocks = Array.from(doc.body.querySelectorAll("p"));

    const exactH1 = "Best Silver Jewelry Gift Ideas for Your Beloved Wife";

    const h2ExactMatches = [
      "Kundan-Inspired Silver Jewellery - For the Traditional Soul",
      "Is your wife someone who embraces cultural charm and timeless aesthetics?",
      "Zircon Collection - For the Modern Muse",
      "Is your wife a boss lady or a fashionista and someone who loves bold artists designs?",
      "Everyday Silver Collection - For the Minimalist at Heart",
      "Is your wife a person that adores minimalism?",
    ];

    const h2StartsWith = [
      "1. Stud Earrings",
      "2. Jhumkas",
      "3. Choker necklace",
      "4. Drop earrings",
      "5. Victorian Necklace",
      "6. Kundan Bangles ",
      "7. Zircon necklaces",
    ];

    return blocks.map((pTag, index) => {
      const fullText = pTag.textContent?.trim() || "";

      // <h1> match
      if (fullText === exactH1) {
        return (
          <h1
            key={index}
            className="text-3xl lg:text-5xl font-bold my-6 text-[#1A1A1A]"
          >
            {fullText}
          </h1>
        );
      }

      // Exact h2 match
      if (h2ExactMatches.includes(fullText)) {
        return (
          <h2
            key={index}
            className="text-2xl lg:text-3xl font-semibold my-4 text-[#1A1A1A]"
          >
            {fullText}
          </h2>
        );
      }

      // Numbered title handling
      const matchedPrefix = h2StartsWith.find((prefix) =>
        fullText.startsWith(prefix)
      );

      if (matchedPrefix) {
        const [headingPart, ...restParts] = fullText.split(":");
        const restContent = restParts.join(":").trim();

        return (
          <div key={index} className="mb-4">
            <h2 className="text-2xl lg:text-3xl font-semibold text-[#1A1A1A] mb-1">
              {headingPart.trim()}:
            </h2>
            {restContent && (
              <p className="text-[#262626] text-xl leading-relaxed">
                <span
                  dangerouslySetInnerHTML={{
                    __html: linkifyKeywords(restContent),
                  }}
                />
              </p>
            )}
          </div>
        );
      }

      // Regular paragraph with keyword link support
      return (
        <p
          key={index}
          className="text-[#262626] text-xl mb-3 leading-relaxed"
        >
          <span
            dangerouslySetInnerHTML={{
              __html: linkifyKeywords(fullText),
            }}
          />
        </p>
      );
    });
  };

  return (
    <>
      {blogs.length > 0 && <SeoHelmet blogData={blogs[0]} />}
      <div className="container mx-auto mb-10">
      <div className="lg:mt-10 mt-5 lg:p-0 p-5">
        {blogs.length > 0 &&
          blogs.map((blog, index) => (
            <div key={index}>
              <div className="lg:mb-5 mb-2">
                <h1 className="text-[#1A1A1A] font-tiemann font-bold lg:text-[40px] text-[24px] mb-3">
                  {blog.heading.trim()}
                </h1>
                <p className="text-[#676767] font-medium text-xl">
                  {formatDate(blog.date, "Month DD, YYYY")}
                </p>
              </div>
            </div>
          ))}
      </div>

      <div
        onClick={() =>
          navigation(`${constants.ADDITIONAL_PATH}/Blog/${title}`)
        }
        className="container mx-auto cursor-pointer lg:p-0 p-5 lg:text-left text-justify"
      >
        {blogs.length > 0 &&
          blogs.map((blog, index) => (
            <div key={index}>
              <img
                src={blog.image}
                alt="Main Banner"
                className="w-full rounded-md"
              />

              <div className="mt-4">
                {renderContentWithHeadings(blog.description_1)}
              </div>
              <div className="mt-4">
                {renderContentWithHeadings(blog.description_2)}
              </div>
              <div className="mt-4">
                {renderContentWithHeadings(blog.description_3)}
              </div>

              
            </div>
          ))}
      </div>

      {/* <h2 className="font-semibold text-2xl text-[#262626] text-center mt-10 lg:p-0 p-5">
        From timeless classics to modern essentials, these must-have items add
        elegance and versatility to any wardrobe.
        <br />
        Shop from Stylori to find your perfect pieces!
      </h2> */}
      </div>
    </>
  );
};

export default StyloriBlog;
